(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alternating-grid"] && !Shopify.designMode) return;
  try {
    
// No JavaScript required for this section

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-flexible-images"] && !Shopify.designMode) return;
  try {
    
  // JavaScript code goes here

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-full-width-cta"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', function() {

    const sections = document.querySelectorAll('.lazy-background-js');

    sections.forEach((section) => {
      const backgroundUrl = section.getAttribute('data-bg').replace(/--/g, '/');
      const image = new Image();
      image.src = backgroundUrl;

      image.addEventListener('load', () => {
        section.style.backgroundImage = "url('" + backgroundUrl + "')";
      });
      
    });
    
    
    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-hero"] && !Shopify.designMode) return;
  try {
    
// No javascript needed for this section

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    

function updateArrows(scrollPosition, sliderWidth) {
 if (scrollPosition == 0) {
    $('.product-slider__prev').attr('disabled', true);
  } else {
    $('.product-slider__prev').attr('disabled', false);
  }
  if (scrollPosition == sliderWidth) {
    $('.product-slider__next').attr('disabled', true);
  } else {
    $('.product-slider__next').attr('disabled', false);
  } 
}
updateArrows($('.product-slider__inner').scrollLeft(), $('.product-slider__inner')[0].scrollWidth - $('.product-slider__inner').outerWidth());
  
// Product Slider
$('.product-slider__inner').scroll(function() {
  var sliderWidth = $('.product-slider__inner')[0].scrollWidth - $('.product-slider__inner').outerWidth();
  var scrollPosition = $('.product-slider__inner').scrollLeft();

  updateArrows(scrollPosition, sliderWidth);
  
});

$('.product-slider__prev').click(function() {
  $('.product-slider__inner').animate({
    scrollLeft: '-=500'
  }, 500);
});

$('.product-slider__next').click(function() {
  $('.product-slider__inner').animate({
    scrollLeft: '+=500'
  }, 500);
});



  } catch(e) { console.error(e); }
})();
})();
